import { Button, Heading, HFlow, VFlow } from 'bold-ui'
import theme from 'config/theme'
import React from 'react'

export const UnificarBasesChaveValidada = () => {
  return (
    <HFlow
      alignItems='flex-start'
      style={{
        border: `1px solid ${theme.pallete.divider}`,
        padding: '1rem',
      }}
    >
      <VFlow>
        <Heading level={3}>Chave validada com sucesso</Heading>
        <p>
          Ao unificar a sua base com a instalação do destinatário, seu sistema será desativado e o novo link de acesso
          esus APS será repassado pelo administrador da instalação destino.
        </p>
      </VFlow>

      <Button size='small' kind='danger'>
        Unificar bases
      </Button>
    </HFlow>
  )
}
